import React from 'react';
import { TextInput, TextInputProps } from './textfield';

export function AccountNumberInput(props: TextInputProps) {
  return (
    <TextInput
      {...props}
      maxLength={15}
      rules={[
        {
          pattern: /^[0-9]*$/,
          message: 'Provide only numbers',
        },
      ]}
    />
  );
}
